import orderBy from 'lodash/orderBy'

import type FiltersForm from 'modules/core/lib/forms/Filters'
import { normalizeText } from 'modules/core/lib/stringUtils'
import { employeeUser } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import getUserByItem from 'modules/payroll_bundle/components/common/helper/getUserByItem'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

const orderItems = <T extends Supplement | PaymentItem>(
  items: T[],
  filtersForm: FiltersForm
): T[] => {
  const sortAttribute = filtersForm.get('sortAttribute').value
  const sortDirection = filtersForm.get('sortDirection').value

  return orderBy(
    items,
    [
      (item: Supplement | PaymentItem) => {
        if (sortAttribute === 'first_name') {
          const employee = employees.get(item.attributes.employee_id)
          const user = employee ? employeeUser(employee) : getUserByItem(item)

          return normalizeText(user?.attributes.first_name ?? '') || ''
        }

        // Disabling this because with big companies can block
        // the page. This code is run in a loop and generateStatuses
        // also have numerouse loops.

        // if (sortAttribute === 'payment_status') {
        //   const paymentStatuses = generateStatuses(items)
        //   const paymentStatus = paymentStatuses[item.id]

        //   return normalizeText(paymentStatus as string) || ''
        // }

        if (
          sortAttribute === 'net_salary' ||
          sortAttribute === 'company_costs' ||
          sortAttribute === 'base_salary' ||
          sortAttribute === 'gross_salary'
        ) {
          return Number(item.attributes[sortAttribute]) || ''
        }

        return normalizeText(item.attributes[sortAttribute]) || ''
      },
    ],
    [sortDirection]
  )
}

export default orderItems
